import { render, staticRenderFns } from "./MobileMenuSectionHeader.vue?vue&type=template&id=38238e84&lang=html&"
import script from "./MobileMenuSectionHeader.vue?vue&type=script&lang=js&"
export * from "./MobileMenuSectionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38238e84')) {
      api.createRecord('38238e84', component.options)
    } else {
      api.reload('38238e84', component.options)
    }
    module.hot.accept("./MobileMenuSectionHeader.vue?vue&type=template&id=38238e84&lang=html&", function () {
      api.rerender('38238e84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/menus/MobileMenuComponents/MobileMenuSectionHeader.vue"
export default component.exports